import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[listFilters]'
})
export class ListFiltersTemplateDirective {
  readonly templateRef = inject(TemplateRef);
}
